/* jshint esnext: true */

const stateButtons = {

	init: function() {

		$( '.state-button' ).on(
			'click',
			this.click
		);

	},


	/**
	 *
	 */
	click: function( event ) {

		event.preventDefault();

		let $button = $( this );
		let newState = $button.data( 'state' );

		// No state set to quit.
		if ( !newState ) {
			return;
		}

		// Set the state!
		states.set( newState );

	}

};